var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"flex items-center text-sm font-semibold leading-4 text-white transition focus:outline-none",class:{
    'rounded px-3 py-2': _vm.rounded !== true,
    'rounded-full w-8 h-8': _vm.rounded === true,
    'bg-primary-600 border-b-2 border-primary-800': _vm.transparent !== true,
    'hover:bg-gray-700': _vm.transparent === true,
  },on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c(_vm.icon,{tag:"component",staticClass:"w-5 h-5"}):_vm._e(),(_vm.iconOnly !== true)?_c('div',{class:{ 'ml-2': _vm.icon }},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }